import { Cond_anteproy } from './../../../models/cond_anteproy.model';
import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: "page-cond_anteproy",
    templateUrl: "./cond_anteproy.component.html",
    styleUrls: ["./cond_anteproy.component.css"]
})

export class Cond_anteproyComponent {
    public rows = [];
    public actualRow;
    public cond_anteproy: Cond_anteproy;
    public form;
    constructor(){

        this.form = new FormGroup({
            fusion :new FormControl('', Validators.required),
            subdivision :new FormControl('', Validators.required),
            estudio :new FormControl('', Validators.required),
            edificacion :new FormControl('', Validators.required),
            otros :new FormControl('', Validators.required)
        })

        if(!JSON.parse(localStorage.getItem("cond_anteproy"))){
            localStorage.setItem("cond_anteproy", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("cond_anteproy"));
            this.form.controls['fusion'].setValue(this.rows[0]?this.rows[0].fusion:'')
            this.form.controls['subdivision'].setValue(this.rows[0]?this.rows[0].subdivision:'')
            this.form.controls['estudio'].setValue(this.rows[0]?this.rows[0].estudio:'')
            this.form.controls['edificacion'].setValue(this.rows[0]?this.rows[0].edificacion:'')
            this.form.controls['otros'].setValue(this.rows[0]?this.rows[0].otros:'')
        }

            this.cond_anteproy = {fusion:'',subdivision:'',estudio:'', edificacion:'',otros:'' };
    }

    add_cond_anteproy(){
        localStorage.setItem("cond_anteproy",JSON.stringify([]));
        this.actualRow = localStorage.getItem("cond_anteproy");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            fusion: this.form.value.fusion, 
            subdivision: this.form.value.subdivision,
            estudio: this.form.value.estudio,
            edificacion: this.form.value.edificacion, 
            otros: this.form.value.otros, 

       })
        localStorage.setItem("cond_anteproy", JSON.stringify(this.rows));
    }
  
    delete_cond_anteproy(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("cond_anteproy", JSON.stringify(this.rows));
            }
        }
    }   
}